import { useField } from 'formik'
import { BrandPlanTactic } from 'types'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import { Checkbox } from 'components/CheckboxGroup/Checkbox'
import Styles from './CrosspostTactics.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { FacebookBrand } from 'blaze-ui/icons/35'
import { LinkedInBrand } from 'blaze-ui/icons/32'
import { TwitterBrand } from 'blaze-ui/icons'
import cx from 'classnames'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'

interface CrosspostTacticsProps {
  className?: string
  applyRedesign?: boolean
}

export const CrosspostTactics = ({ className, applyRedesign = false }: CrosspostTacticsProps = {}) => {
  const isOnboardingRedesign = useIsOnboardingRedesign() && applyRedesign
  const [{ value }, , { setValue }] = useField<BrandPlanTactic[]>('tactics')
  const textVariant = isOnboardingRedesign ? 'primary' : 'largeList'

  return (
    <CheckboxGroup
      value={value}
      onChange={(value) => setValue(value as BrandPlanTactic[])}
      className={cx(Styles.group, className, { [Styles.applyRedesign]: isOnboardingRedesign })}
      aria-label="Crosspost platforms"
    >
      <Checkbox
        value={BrandPlanTactic.Instagram}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.Instagram}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
      >
        <div className={Styles.checkboxLabel}>
          <InstagramBrand size={20} />
          <Text variant={textVariant} color="var(--dark-80)">
            Instagram
          </Text>
        </div>
      </Checkbox>
      <Checkbox
        value={BrandPlanTactic.Facebook}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.Facebook}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
      >
        <div className={Styles.checkboxLabel}>
          <FacebookBrand size={20} />
          <Text variant={textVariant} color="var(--dark-80)">
            Facebook
          </Text>
        </div>
      </Checkbox>
      <Checkbox
        value={BrandPlanTactic.LinkedIn}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.LinkedIn}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
      >
        <div className={Styles.checkboxLabel}>
          <LinkedInBrand size={20} />
          <Text variant={textVariant} color="var(--dark-80)">
            LinkedIn
          </Text>
        </div>
      </Checkbox>
      <Checkbox
        value={BrandPlanTactic.Twitter}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.Twitter}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
      >
        <div className={Styles.checkboxLabel}>
          <TwitterBrand size={20} />
          <Text variant={textVariant} color="var(--dark-80)">
            Twitter
          </Text>
        </div>
      </Checkbox>
    </CheckboxGroup>
  )
}
